import React, { useState } from 'react';
import { FormError } from '../formErrorScroll';
import './style.scss';

export type SpinboxProps = {
  value: number ;
  min?: number;
  max?: number;
  step?: number;
  name?: string;
  unit?: string;
  onChange: (value: number | null) => void;
  onBlur?: (e: React.FocusEvent<any, Element>) => void;
  error?: string;
  unitPosition?: 'right_8rem' | 'right_6rem';
};

export const Spinbox = ({ 
    value, 
    min, 
    max, 
    step,
    name, 
    unit,
    onChange, 
    onBlur, 
    error,
    unitPosition = 'right_8rem'
}: SpinboxProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const numericValue = value ?? min ?? null;
  const formattedValue =
    numericValue !== null && Number.isFinite(numericValue) ? numericValue.toLocaleString() : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isFocused) {
      onChange?.(e.target.valueAsNumber);
      return;
    }
    const raw = e.target.value.replaceAll(',', '');
    const parsed = raw === '' ? null : Number(raw);
    onChange?.(Number.isFinite(parsed) ? parsed : null);
  };

  return (
    <div className='spinboxWrapper'>
        <div className='spinbox'>
            <input
                id="spinbox"
                type={isFocused ? 'number' : 'text'}
                name={name}
                inputMode='numeric'
                value={isFocused ? numericValue ?? '' : formattedValue}
                onChange={handleChange}
                min={isFocused ? min : undefined}
                max={isFocused ? max : undefined}
                step={isFocused ? step : undefined}
                onFocus={() => setIsFocused(true)}
                onBlur={(e) => {
                  setIsFocused(false);
                  onBlur?.(e);
                }}
            />
            {unit && <div className={`spinbox_unit ${unitPosition}`}>{unit}</div>}
    </div>
    <FormError className="spinboxWrapper_error" error={error}/>
    </div>
  );
}; 